import React from 'react'
import PropTypes from 'prop-types'
import Slider from '@material-ui/core/Slider'
import { ThemeProvider } from '@material-ui/core/styles'

const InputSlider = ({
  meta: { error, touched },
  input: { onChange, value },
  handleOnChange,
  errorMessage,
  theme,
  testId,
  ...rest
}) => (
  <ThemeProvider theme={theme}>
    <Slider
      {...rest}
      data-testid={testId}
      value={value}
      onChange={(_, v) => {
        if (handleOnChange) {
          handleOnChange(v)
        }
        onChange(v)
      }}
    />
    {touched && error && (errorMessage || error) && (
      <small className="jisrSelect__error_msg">{error}</small>
    )}
  </ThemeProvider>
)

InputSlider.propTypes = {
  meta: PropTypes.shape(),
  testId: PropTypes.string,
  input: PropTypes.shape(),
  handleOnChange: PropTypes.func,
  errorMessage: PropTypes.string,
  theme: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default InputSlider
